import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateServiceType from "./create/createServiceType";
import UpdateServiceType from "./update/updateServiceType";
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;
const ServiceTypeContext = createContext();

function ServiceType() {

  const [dataList, setDataList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.ServiceType.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowData(results);
      else 
      setShowData(dataList);
    } else 
    setShowData(dataList);
  }

  const openUpdate = (ServiceTypeID, ServiceType) => {
    var list = [];
    list.push({
      ServiceTypeID: ServiceTypeID,
      ServiceType: ServiceType
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllServiceType() {
    axios
      .get("/getAllServiceType")
      .then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    getAllServiceType();
  }, []);

  return (
    <ServiceTypeContext.Provider value={{dataList, setDataList, data, setShowData}}>
      <div className="formContent">
        <CreateServiceType show={show} onClick={handleClose}/>
        <UpdateServiceType show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ປະເພດນວດ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ປະເພດນວດ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.ServiceType}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.ServiceTypeID} type="button" onClick={() => openUpdate(x.ServiceTypeID, x.ServiceType)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </ServiceTypeContext.Provider>
  );
};

export {ServiceTypeContext};
export default ServiceType;
